import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';
import { fetchTeamMetrics } from '../../../../../../api/MetricsService';
import { teamsEndpoint } from '../../../../../../api/Teams';
import Auth from '../../../../../../routes/Auth';

import { handleSelectChange, arrayUniqueFilter } from '../../../utils';
import { formatNumber } from '../../../../../../api/PerformanceFeedback';

import BannerLayout from '../../../layouts/banner';

import {
  FormulaName,
  FormulaValue
} from '../../../components/ui';

class GrossMarginsStep3 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      sellingPrice: 0,
      unitCost: 0
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(
      teamsEndpoint()
    ).then(res => {

      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Negative gross margins").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      const game_id = Auth.getGameId();
      const course_id = Auth.getCourseId();

      Promise.all([
        fetchTeamMetrics(team_id, roundId),
        getRequest(`${process.env.REACT_APP_API_URL}team/report/income_statement/?round_number=${activeRound}&team_id=${team_id}`),
        getRequest(`${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}&team_id=${team_id}`),
        getRequest(`${process.env.REACT_APP_API_URL}team/inventory_balances/?round_number=${activeRound}&team_id=${team_id}`),
        getRequest(`${process.env.REACT_APP_API_URL}v2/reports/performancefeedbacks/?round_number=${activeRound}`)
      ])
        .then(res => {
          const metrics = res[0];
          const currentRoundMetrics = metrics.find(i => Number(i.round_number) === Number(activeRound));

          const netRevenues = currentRoundMetrics ? Number(currentRoundMetrics.net_revenues || 0) : 0;
          const unitsSold = currentRoundMetrics ? Number(currentRoundMetrics.units_sold || 0) : 0;
          let sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;

          const incomeStatement = res[1].body;
          const currentRoundIncomeStatement = incomeStatement.find(i => i.round === roundId);
          const costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
          let unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;

          const performanceFeedbacks = res[4].body.results;

          const pfReport = performanceFeedbacks.find(i => (
            Number(i.course) === course_id
            && Number(i.game) === game_id
            && Number(i.round) === roundId
            && Number(i.team) === team_id
            && i.type === 'Negative gross margins'
          ));

          if (!!pfReport) {
            const message = JSON.parse(pfReport.message);
            if (message.faild_products && message.faild_products.length > 0) {
              const productId = Number(message.faild_products[0]);
              const priceForecastsRaw = res[2].body;
              const priceForecastsProduct = priceForecastsRaw.find(i => Number(i.product) === productId);
              const inventoryBalancesRaw = res[3].body;
              const inventoryBalancesProduct = inventoryBalancesRaw.find(i => Number(i.product) === productId);

              if (priceForecastsProduct && inventoryBalancesProduct) {
                sellingPrice = Number(priceForecastsProduct.price);
                unitCost = Number(inventoryBalancesProduct.cost_per_unit);
              }
            }
          }

          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
            sellingPrice,
            unitCost,
          })
        })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      sellingPrice,
      unitCost
    } = this.state;

    const { previousShownErrors } = this.props;

    let differenceFormulaValue;
    if (sellingPrice - unitCost < 0) {
      differenceFormulaValue = <b>{formatNumber(sellingPrice - unitCost)}</b>;
    } else {
      differenceFormulaValue = <Fragment>{formatNumber(sellingPrice - unitCost)}</Fragment>;
    }

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Gross Margins"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams might be running a non-profit or a growth-at-all-cost strategy.`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <p>This team is selling their product below what it cost for them to make the product.</p>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <FormulaName background="#4CC7D1" color="rgba(0, 27, 59, 0.94)">
              Gross Profit Margin<br />
              Per Unit of Sale
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Selling Price - Unit Cost
              <span className='divider' />
              Selling Price
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              {differenceFormulaValue}
              <span className='divider' />
              {formatNumber(sellingPrice)}
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#D5D9DD',
          background: '#D7F0F2',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default GrossMarginsStep3;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/gross-margins/step3.js